import React, {Component} from 'react';
import ArchivContainer from "../../utils/ArchivContainer";
import StaticVideoFunctions from "../../utils/StaticVideoFunctions";
import PropTypes from "prop-types";

class SoftwareVideoCategoryContainer extends Component {

    static propTypes = {
        videoSource: PropTypes.string.isRequired,
        handleStateChange: PropTypes.func.isRequired,
    };

    static defaultProps = {
        categoryList: [],
    };

    constructor(props) {

        super(props);

        this.state = {};

        this.userRightSection = 'VideoCategory';
        this.contentCases = {
            'ok': null,
            'locked': 'Category is locked!',
            'expired': 'Permission expired!',
            'soon': 'Coming soon.',
        };

        this.translate = this.props.baseData.translate;

    }

    navigate(event, linkTo) {

        if (this.props.baseData.pageNavigation) {
            event.preventDefault();

            this.props.baseData.pageNavigation(linkTo);
        }

        return null;

    }

    getStatusCase(categoryId) {

        let statusCase = 'ok';

        if (this.props.videoSource !== 'YouTube') {
            statusCase = this.props.handleStatusCase(this.userRightSection, categoryId);
        }

        return statusCase;

    }

    renderCategories() {

        const videoSource = this.props.videoSource;
        const categories = this.props.categoryList;

        if (typeof categories !== 'undefined' && categories) {
            if (typeof categories['category-' + videoSource] !== 'undefined') {
                if (categories['category-' + videoSource].length > 0) {
                    let renderedCategories = [];

                    for (let ix in categories['category-' + videoSource]) {
                        let category = categories['category-' + videoSource][ix];

                        if (typeof category !== 'object') continue;

                        renderedCategories.push(
                            <ArchivContainer
                                key={category.category_id}
                                archivId={category.category_id}
                                classes="videoHover col-lg-2"
                                title={category.category_name}
                                sub={category.category_videos + ' ' + ((category.category_videos > 1) ? this.translate('videos') : this.translate('video'))}
                                content={this.contentCases[this.getStatusCase(category.category_id)]}
                                status={this.getStatusCase(category.category_id)}
                                backgroundImage={StaticVideoFunctions.getBackgroundImage(category.category_image_id, this.props.videoSource)}
                                handleNavigation={this.props.baseData.handleNavigation}
                                handleStateChange={this.props.handleStateChange}
                                onClick={this.props.onClick}
                            />
                        );
                    }

                    return renderedCategories;
                }
            }
        }

        return this.translate('noCategoriesFound');

    }

    render() {

        const renderCategories = this.renderCategories();

        return (
            <div className="VideoCategoryContainer">
                <nav>
                    <h1>{this.translate('videoCategory')}</h1>
                </nav>

                <div className="archivArea">
                    <div className="clearfix">
                        {renderCategories}
                    </div>
                </div>

                {/*<div className="bottomLinks clearfix">
                    <a className="prewLink" onClick={(e) => this.navigate(e, 'software')}>{this.translate('backToOverview')}</a>
                </div>*/}
            </div>
        );

    }

}

export default SoftwareVideoCategoryContainer;